import { apiGet, apiPost, apiPutId, apiDelete, unwrapList, unwrapData } from './helpers'

const PATH = 'weightloss/treatments'

export default {
  list: () => apiGet(PATH).then(unwrapList),
  getById: id => apiGet(`${PATH}/${id}`).then(unwrapData),
  create: data => apiPost(PATH, data).then(r => r),
  update: (id, data) => apiPutId(PATH, id, data),
  remove: id => apiDelete(`${PATH}/${id}`),
}
